@for (incidentCase of arrIncidents(); track $index) {
<!-- Título del grupo -->
<div
  class="p-5 mt-5 mb-3 bg-red-4 font-roboto-500 text-16 rounded-5 text-grey-1 max-sm:text-13 max-sm:p-3 max-sm:mt-2"
>
  {{ incidentCase.title }}
</div>

<!-- Lista de incidentes -->
<div class="flex flex-col gap-5">
  @for (incident of incidentCase.incidents; track $index) {
  <div
    class="flex items-center gap-2"
    [class.flex-row-reverse]="incident.TeamGround === awayTeam"
    [class.justify-center]="incident.TeamGround === isNeutral"
  >
    <!-- Tiempo (no aplica en final de partido) -->
    @if (incident.Kind !== isEND) {
    <div class="font-roboto-600 text-grey-2 max-w-[30px] w-full text-16">
      {{ incident.GameTime }}'
    </div>
    }

    <!-- Ícono o marcador si es gol -->
    @if (isGOAL.includes(incident.Kind)) {
    <div class="flex items-center gap-1">
      <img
        alt="incident"
        class="object-contain"
        [src]="getImgByKind(incident.Kind)"
      />
      <span class="font-roboto-700 text-18 text-nowrap">
        {{ incident.HomeScore }} - {{ incident.AwayScore }}
      </span>
    </div>
    } @else {
    <img
      alt="incident"
      class="object-contain w-[20px]"
      [src]="getImgByKind(incident.Kind)"
    />
    }

    <!-- Descripción -->
    <div
      nz-col
      class="gap-2 text-incident max-sm:gap-1"
      [class.inline-flex]="isGOAL.includes(incident.Kind)"
      [class.grid]="!isGOAL.includes(incident.Kind)"
      [class.max-sm:grid]="isGOAL.includes(incident.Kind)"
      [class.text-left]="incident.Kind !== isEND"
      [class.justify-start]="incident.Kind !== isEND"
    >
      @if(incident.Kind === isPenalMissed){
      <span class="font-roboto-600">
        ({{ "penalty_missed" | translate }})
      </span>

      }

      <!-- Gol -->
      @if (isGOAL.includes(incident.Kind) && incident.Player) {
      <!--  -->
      @if (incident.TeamGround !== awayTeam) {

      <span
        class="font-roboto-600 text-14"
        [class.text-red-3]="
          isOWNGOAL === incident.Kind || isPenalMissed === incident.Kind
        "
      >
        {{ getNameIncident(incident.Player) }}
      </span>
      <!--  -->
      @if(incident.Kind === isOWNGOAL){
      <span class="font-roboto-600 text-14">
        ({{ "onw_goal" | translate }})
      </span>
      }
      <!--  -->

      }
      <!--  -->
      @if (incident.AssistPlayer) {
      <span class="text-grey-2 font-roboto-500">
        ({{ getNameIncident(incident.AssistPlayer) }})
      </span>

      }
      <!--  -->
      @if (incident.TeamGround === awayTeam) {
      <!--  -->
      @if(incident.Kind === isOWNGOAL){
      <span class="font-roboto-600 text-14">
        ({{ "onw_goal" | translate }})
      </span>
      }
      <!--  -->
      <span
        class="font-roboto-600 text-14"
        [class.text-red-3]="
          isOWNGOAL === incident.Kind || isPenalMissed === incident.Kind
        "
      >
        {{ getNameIncident(incident.Player) }}
      </span>
      } }

      <!-- Penal -->
      @if (isPenaltyCase.includes(incident.Kind) && incident.Player) {
      <!--  -->
      <!-- @if (incident.TeamGround === awayTeam) {
      <span class="text-grey-2 font-roboto-500">
        {{ getNameIncident(incident.Player) }}
      </span>
      } @else {
      <span class="text-grey-2 font-roboto-500">
        {{ getNameIncident(incident.Player) }}
      </span>
      }  -->
      }

      <!-- Tarjeta -->
      @if (isCard.includes(incident.Kind) && incident.Player) {
      <span class="font-roboto-600">
        {{ getNameIncident(incident.Player) }}
      </span>
      }

      <!-- Cambio -->
      @if ( incident.Kind === isSustitution && incident.Player &&
      incident.SubstitutePlayer ) {
      <span class="text-grey-2 font-roboto-500">
        {{ getNameIncident(incident.Player) }}
      </span>
      <span class="font-roboto-600">
        {{ getNameIncident(incident.SubstitutePlayer) }}
      </span>
      }

      <!-- Fin de tiempo -->
      <!-- VAR -->
      @if (isEndPeriod.includes(incident.Kind)) {
      <div nz-row class="gap-2">
        @if(incident.Kind === 'VAR'){
        <!--  -->
        @if(incident.VarResult !== null){
        <span class="font-roboto-500 font-normal">
          {{ getTextVarResult(incident.VarResult) }}
        </span>
        }
        <!--  -->
        @if(incident.VarReason !== null){
        <span class="font-roboto-500 font-normal">
          {{ getTextVarReason(incident.VarReason) }}
        </span>
        }
        <!--  -->
        }@else {
        <span class="font-roboto-500 font-normal">
          {{ getTextEndPeriod(incident.Kind) }}
        </span>
        }
      </div>
      }
    </div>
  </div>
  }
</div>
}
